export default __webpack_public_path__ + "static/media/Warlord's Spell Glaive.87b48243.jpg";